import {Alert, Div} from 'components';
import {Ecolors} from 'constant';
import React, {useEffect, useRef, useState} from 'react';
import {useDispatch} from 'react-redux';
import {getListProduct, loadProduct} from 'reducer/investment';
import {apiInvestment} from 'services/apis/apiInvestment';
import {useAppSelector} from 'store/hooks';
import {widthScreen} from 'utils';
import OrderBuyStep1 from './OrderBuyStep1';
import OrderBuyStep2 from './OrderBuyStep2';
import OrderBuyStep3 from './OrderBuyStep3';

interface Props {
  setStepTimeLine: (a: number) => void;
  stepTimeLine?: number;
  initData?: any;
}

function OrderBuy({setStepTimeLine, stepTimeLine, initData}: Props) {
  // state order buy
  const I18nState = useAppSelector(state => state.languages.I18nState);
  const [product, setProduct] = useState<any>(null);
  const listProduct = useAppSelector(state => getListProduct(state));
  const [scheme, setScheme] = useState<any>(null);
  const [listScheme, setListScheme] = useState<Array<any>>([]);
  const [amount, setAmount] = useState<string>('');
  const [beginBuyAutoStartDate, setBeginBuyAutoStartDate] =
    useState<string>('');
  const [currentSession, setCurrentSession] = useState<any>(null);
  const [excuseTempVolumn, setExcuseTempVolumn] = useState<any>(null);
  const [bankSuperVisory, setBankSuperVisory] = useState<any>(null);

  const [orderData, setOrderData] = useState<any>({});
  // control header
  const [loading, setLoading] = useState<boolean>(false);

  const scrollViewRef = useRef<any>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadProduct({}));
    return () => {};
  }, []);

  useEffect(() => {
    if (initData?.product) {
      onChangeProduct(initData?.product);
    }
    if (initData?.scheme) {
      setScheme(initData?.scheme);
    }
    return () => {};
  }, [initData]);

  const onNext = () => {
    setStepTimeLine(stepTimeLine + 1);
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTo({
        x: (stepTimeLine || 1) * widthScreen,
        animated: true,
      });
    }
  };

  const onPre = (step?: number) => {
    setStepTimeLine(stepTimeLine - 1);
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTo({
        x: step
          ? (step - 1) * widthScreen
          : stepTimeLine
          ? (stepTimeLine - 2) * widthScreen
          : widthScreen,
        animated: true,
      });
    }
    if (step) {
      Promise.all([
        setProduct(null),
        setScheme(null),
        setExcuseTempVolumn(null),
        setBankSuperVisory(null),
        setCurrentSession(null),
        setAmount(''),
        setBeginBuyAutoStartDate(''),
      ]);
    }
  };

  const onScroll = (e: any) => {
    const offset = Math.round(e.nativeEvent.contentOffset.x / widthScreen) + 1;
    if (offset != stepTimeLine) {
      setStepTimeLine(offset);
    }
  };
  //

  const onExcuseTempVolumn = async () => {
    try {
      const res = await apiInvestment.excuseTempVolume({
        amount: amount.replace(/[,|.]/g, ''),
        productId: product?.id,
        productProgramId: scheme.id,
      });
      if (res.status == 200) {
        setExcuseTempVolumn(res.data);
        return;
      }
      setExcuseTempVolumn(null);
      return;
    } catch (error: any) {
      setExcuseTempVolumn(null);
      Alert.showError({
        content: I18nState == 'vi' ? error.message : error.messageEn,
        multilanguage: false,
      });
    }
  };

  const onChangeProduct = async (e: any) => {
    setLoading(true);
    setProduct(e);
    setScheme(null);
    setAmount('');
    try {
      const res = await apiInvestment.loadProductDetails({
        id: e.id,
      });
      const ses = await apiInvestment.checkOverCurrentSession({
        productId: e.id,
      });
      const aaa = await apiInvestment.loadBuy({
        id: e.id,
      });

      if (res.status == 200) {
        setListScheme(aaa.data);
      }
      if (ses.status == 200) {
        setCurrentSession(ses.data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const switchData = () => {
    switch (stepTimeLine) {
      case 1:
        return (
          <OrderBuyStep1
            loading={loading}
            onNext={onNext}
            product={product}
            listScheme={listScheme}
            setListScheme={setListScheme}
            onExcuseTempVolumn={onExcuseTempVolumn}
            onChangeProduct={onChangeProduct}
            listProduct={listProduct}
            setProduct={setProduct}
            scheme={scheme}
            setScheme={setScheme}
            amount={amount}
            beginBuyAutoStartDate={beginBuyAutoStartDate}
            setBeginBuyAutoStartDate={setBeginBuyAutoStartDate}
            setAmount={setAmount}
            currentSession={currentSession}
            setCurrentSession={setCurrentSession}
            setExcuseTempVolumn={setExcuseTempVolumn}
            excuseTempVolumn={excuseTempVolumn}
            bankSuperVisory={bankSuperVisory}
            setBankSuperVisory={setBankSuperVisory}
          />
        );
      case 2:
        return (
          <OrderBuyStep2
            stepTimeLine={stepTimeLine}
            onNext={onNext}
            onPre={onPre}
            product={product}
            beginBuyAutoStartDate={beginBuyAutoStartDate}
            setOrderData={setOrderData}
            scheme={scheme}
            amount={amount}
            currentSession={currentSession}
            excuseTempVolumn={excuseTempVolumn}
            bankSuperVisory={bankSuperVisory}
          />
        );
      case 3:
        return (
          <OrderBuyStep3
            beginBuyAutoStartDate={beginBuyAutoStartDate}
            orderData={orderData}
            stepTimeLine={stepTimeLine}
            excuseTempVolumn={excuseTempVolumn}
            bankSuperVisory={bankSuperVisory}
            amount={amount}
            currentSession={currentSession}
            onPre={onPre}
            product={product}
            scheme={scheme}
          />
        );
      default:
        return <></>;
    }
  };

  return (
    <Div backgroundColor={Ecolors.whiteColor} width={'100%'}>
      {switchData()}
    </Div>
  );
}

export default React.memo(OrderBuy);
